import { render, staticRenderFns } from "./MergeCate02Parent.vue?vue&type=template&id=4e9f3853"
import script from "./MergeCate02Parent.vue?vue&type=script&lang=js"
export * from "./MergeCate02Parent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports